import { z } from 'zod';

export const Availability = z.object({
  day: z.string(),
  isHoliday: z.boolean().optional(),
  slots: z.array(
    z.object({
      id: z.string(),
      from: z.string(),
      to: z.string(),
      type: z.enum(['agent', 'inbox', 'webclient']),
      targetId: z.string(),
    }),
  ),
  exclude: z.array(z.object({ date: z.string(), id: z.string() })).optional(),
});

export const HandoverConfigSchema = z.array(Availability);
